import React from 'react';
import Styles from './ModalComponent.css';
import clsx from 'clsx';

/**
 *
 * @param {import('../../../../types/ModalComponent').ModalComponentProps} props
 * @returns
 */
function ModalComponent({
  id,
  children,
  open,
  setOpen,
  disableSurface,
  allowSurfaceScroll,
  surfaceProps,
  hideCloseButton = false,
  className = '',
}) {
  return (
    <>
      {open && <span className="modal-backdrop" />}
      <div id={id} className={clsx('modal-component', open && 'open', className)}>
        {disableSurface ? (
          <div className="modal-content">{children}</div>
        ) : (
          <div
            {...surfaceProps}
            className={clsx(
              'modal-surface',
              allowSurfaceScroll && 'allow-scroll',
              surfaceProps?.className,
            )}
          >
            {!hideCloseButton && (
              <button
                type="button"
                className="close-modal-btn"
                onClick={(ev) => {
                  ev.preventDefault();
                  setOpen(false);
                }}
              >
                <img src="assets/shared/ic-close-modal.svg" alt="fechar" />
              </button>
            )}
            <div className="modal-content">{children}</div>
          </div>
        )}
      </div>

      <style jsx global>
        {Styles}
      </style>
    </>
  );
}

export default ModalComponent;
